import React, { useContext } from 'react'
import SearchContext from 'modules/react/search/SearchContext'

export default function Filters () {
  const { filters, selectFilter, unselectFilter, isFilterSelected } = useContext(SearchContext)

  const filterName = (filterSlug) => {
    return {
      typer: 'Kursustype',
      former: 'Undervisningsform',
      forloeb: 'Forløb',
      kategorier: 'Kategori',
      malgruppe: "Målgruppe",
    }[filterSlug] || filterSlug
  }

  const toggleFilterSelected = (e, type) => {
    const { checked, value } = e.target

    const single = type === 'forloeb'

    if (checked) {
      selectFilter(type, value, single)
    } else {
      unselectFilter(type, value, single)
    }
  }

  const renderFilters = () => {
    return Object.keys(filters).map((filterSlug, index) => {
      let style = index === 0 ? { display: 'block' } : {}
      let cls = index === 0 ? ' open' : ''
      return (
        <div className={'search-page__filter slide-toggle-wrapper' + cls} key={filterSlug} data-slide-toggle-breakpoint="9999">
          <div className="search-page__filter-title tagline tagline--prim tagline--bold slide-toggle-button">{filterName(filterSlug)}</div>
          <div className="search-page__filter-content slide-toggle-content" style={style}>
            <ul className="search-page__filter-list">
              {filters[filterSlug].map((filter) => {
                return (
                  <li className="search-page__filter-item" key={`${filterSlug}_${filter.slug}`}>
                    <input type="checkbox" value={filter.slug} id={filter.slug}
                           name={`${filterSlug}_${filter.slug}`} disabled={!filter.enabled}
                           defaultChecked={isFilterSelected(filterSlug, filter.slug)}
                           onChange={(e) => toggleFilterSelected(e, filterSlug)}
                    />
                    <label htmlFor={filter.slug}>{filter.label}</label>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )
    })
  }

  return (
    <div>
      {renderFilters()}
    </div>
  )
}